import type { PageProps } from "../pageProps";
import { AboutRoot } from "./aboutParts2";

export const AboutPage = (_props: PageProps) => <AboutRoot />;
